export default "__VITE_ASSET__Cn$TJN5O__"